function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M34.3511 17.1756C34.3511 26.6614 26.6614 34.3511 17.1756 34.3511C7.68977 34.3511 0 26.6614 0 17.1756C0 7.68977 7.68977 0 17.1756 0C26.6614 0 34.3511 7.68977 34.3511 17.1756Z",
  fill: "#FFDC4A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4482 24.9045C13.9421 24.9045 14.3425 24.4974 14.3425 23.9953V19.1305H23.7161C24.7682 19.1398 25.2964 17.8991 24.5642 17.1687L21.6569 14.2886L24.5643 11.4084C25.2967 10.6774 24.7678 9.43724 23.7162 9.44659H13.1825C12.5419 9.44659 12.0225 9.96113 12.0225 10.5958V23.9953C12.0225 24.4974 12.4229 24.9045 12.9168 24.9045H13.4482Z",
  fill: "#AD8D07"
});

function SvgGetReady(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgGetReady);
export default __webpack_public_path__ + "static/media/get-ready.343b4ec6.svg";
export { ForwardRef as ReactComponent };